import api from '../api.js';
import db from '../../versa/db.js';
import crud from '../../versa/crud.js';
import dialog from '../../versa/dialog.js';
import filter, { resolveFilterLabelsToIds } from '../../versa/filter.js';
import router from '../../versa/router.js';
import { notify, ask } from '../../versa/msgbox.js';
import { flatten, deepen } from '../../versa/record.js';
import pdf from '../../versa/pdf.js';
import view from '../views/input-orders.js';
import form from '../forms/input-orders.js';
import upload_form from '../forms/input-orders-upload.js';
import xml_import_form from '../forms/input-orders-import-xml.js';
import order_upload_result_view from '../views/order-upload-result.js';
import formset from '../../versa/formset.js';
import * as types from '../types.js';

const inputOrders = function()
{

	let input_orders_crud = crud.create({
		async loadBaseData()
		{
			api.call(api.list_companies, this.queryAll()).then((data) => db.set('companies', data).catch(error => notify(error)));
			api.call(api.list_programs, this.queryAll()).then((data) => db.set('programs', data).catch(() => {}));
			api.call(api.list_receipt_types, this.queryAll()).then((data) => db.set('receipt_types', data).catch(() => {}));
			api.call(api.list_suppliers, this.queryAll()).then((data) => db.set('suppliers', data).catch(error => notify(error)));
			api.call(api.list_customers, this.queryAll()).then((data) => db.set('customers', data).catch(() => {}));
			api.call(api.list_carriers, this.queryAll()).then((data) => db.set('carriers', data).catch(error => notify(error)));
			api.call(api.list_products, this.queryAll()).then((data) => db.set('products', data).catch(error => notify(error)));
			api.call(api.list_units, this.queryAll()).then((data) => db.set('units', data).catch(error => notify(error)));
			api.call(api.list_users, this.queryAll()).then((data) => db.set('users', data).catch(error => notify(error)));
		},
		async queryData(query)
		{
			return await api.call(api.list_input_orders, query);
		},
		async loadRecord(id)
		{
			let _record = await api.call(api.select_input_order, ...JSON.parse(id));
			if (_record && Array.isArray(_record.payment_prazos))
				_record.payment_prazos = JSON.stringify(_record.payment_prazos);
			else if (_record && _record.payment_prazos != null && typeof _record.payment_prazos !== 'string')
				_record.payment_prazos = JSON.stringify(_record.payment_prazos);
			if (_record?.payment_base_date && typeof _record.payment_base_date === 'string' && _record.payment_base_date.length > 10)
				_record.payment_base_date = _record.payment_base_date.slice(0, 10);
			return flatten(_record, 'items');
		},
		async saveRecord(data, old_data)
		{
			data = deepen(data, 'items');
			const isReturn = data.is_return == '1';
			let statusVal = Number(data.status);
			try {
				const company = await db.get('companies', data.company_id)
					|| await db.get('companies', [data.company_id]);
				if (company?.input_orders_require_approval) {
					if (old_data)
						statusVal = Number(old_data.status);
					else
						statusVal = 10;
				}
			} catch (_) { /* mantém status do form */ }
			let _record = {
				reference: data.reference,
				supplier_id: isReturn ? null : Number(data.supplier_id),
				customer_id: isReturn ? Number(data.customer_id) : null,
				carrier_id: Number(data.carrier_id),
				program_id: data.program_id != null && data.program_id !== '' ? Number(data.program_id) : null,
				freight_type: data.freight_type,
				freight_value: Number(data.freight_value),
				discount: Number(data.discount),
				notes: data.notes?.trim(),
				empenho_number: (data.empenho_number && String(data.empenho_number).trim()) ? String(data.empenho_number).trim().replace(/\s+/g, '') : null,
				amil_oc: (data.amil_oc && String(data.amil_oc).trim()) ? String(data.amil_oc).trim().slice(0, 60) : null,
				nf_number: (data.nf_number && String(data.nf_number).trim()) ? String(data.nf_number).trim().slice(0, 120) : null,
				receipt_type_id: (data.receipt_type_id != null && data.receipt_type_id !== '') ? Number(data.receipt_type_id) : null,
				is_return: isReturn,
				status: statusVal,
				payment_installment_count: (() => {
					const n = Number(data.payment_installment_count);
					return Number.isFinite(n) && n > 0 ? n : null;
				})(),
				payment_prazos: (() => {
					const count = Number(data.payment_installment_count);
					const list = [];
					const n = Number.isFinite(count) && count > 0 ? Math.min(12, count) : 0;
					for (let i = 0; i < n; i++) {
						const raw = data[`io_prazo_${i}`];
						const days = Number(raw);
						list.push(Number.isFinite(days) ? days : 0);
					}
					if (list.length)
						return list;
					if (typeof data.payment_prazos === 'string' && data.payment_prazos.trim()) {
						try {
							const parsed = JSON.parse(data.payment_prazos);
							return Array.isArray(parsed) ? parsed.map((x) => Number(x) || 0) : null;
						} catch (_) {
							return null;
						}
					}
					return Array.isArray(data.payment_prazos) ? data.payment_prazos.map((x) => Number(x) || 0) : null;
				})(),
				payment_base_date: (data.payment_base_date && String(data.payment_base_date).trim())
					? String(data.payment_base_date).trim().slice(0, 10)
					: null,
				items: (data.items || [])
				.filter(item => item && (item.product_id != null && item.product_id !== '') && Number(item.product_id) > 0)
				.map(item => ({ 
					product_id: Number(item.product_id),
					unit_id: Number(item.unit_id),
					quantity: Number(item.quantity),
					unit_price: Number(item.unit_price),
					serial: (item.serial && String(item.serial).trim()) ? String(item.serial).trim().slice(0, 20) : null,
				}))
			};
			if (old_data)
				return await api.call(api.update_input_order, data.company_id, data.id, _record);
			else
				return await api.call(api.insert_input_order, data.company_id, _record);
		},
		editFilter() {
			filter.edit(this.applyFilter.bind(this), this.filter);
		},
		async applyFilter(data) {
			this.filter = await resolveFilterLabelsToIds(data, this.fieldspecs);
			this.loadPage(1);
		},
		uploadFromSpreadsheet()
		{
			const showResult = (result) =>
			{
				notify(order_upload_result_view(result, 'input'), 'Resultado do upload');
				this.loadPage();
				fs.destroy();
			};
			const sendRequest = async (data) =>
			{
				const formNode = document.querySelector(upload_form.form.selector);
				const fileInput = formNode?.querySelector('#file');
				const file = fileInput?.files?.[0];
				if (!file)
				{
					notify('Selecione um arquivo CSV ou XLSX.');
					return;
				}
				const company_id = data.company_id;
				if (!company_id)
				{
					notify('Selecione a empresa.');
					return;
				}
				const fd = new FormData();
				fd.append('file', file);
				fd.append('supplier_id', data.supplier_id);
				fd.append('program_id', data.program_id || '');
				const result = await api.call(api.upload_input_order, company_id, fd);
				if (result)
					showResult(result);
			};
			const setupTemplateLink = (fs) =>
			{
				const link = fs.dialog.getNode().querySelector('#download-template');
				if (link)
				{
					link.onclick = async (e) =>
					{
						e.preventDefault();
						const company_id = fs.form.getValues().company_id;
						if (!company_id)
						{
							notify('Selecione a empresa para baixar o modelo.');
							return;
						}
						const csv = await api.call(api.order_upload_template, company_id);
						if (csv && typeof csv === 'string')
						{
							const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
							const a = document.createElement('a');
							a.href = URL.createObjectURL(blob);
							a.download = 'modelo_pedido_upload.csv';
							a.click();
							URL.revokeObjectURL(a.href);
						}
					};
				}
			};
			const fs = formset.create(upload_form, sendRequest);
			fs.init = (() =>
			{
				Object.getPrototypeOf(fs).init.call(fs);
				setupTemplateLink(fs);
			})();
		},
		importFromXml()
		{
			const crudRef = this;
			const openConfirm = async (company_id, program_id, preview) =>
			{
				const matched = preview.items_matched || [];
				const unmatched = preview.items_unmatched || [];
				const suppliers = await db.list('suppliers').catch(() => []) || [];
				const companySuppliers = suppliers.filter((s) => String(s.company_id) === String(company_id));
				const supplierOptions = companySuppliers.map((s) =>
					`<option value="${s.id}">${(s.cnpj || '').toString()} — ${(s.nick || s.name || '').toString()}</option>`
				).join('');
				const matchedRows = matched.map((it, i) => `
					<tr data-kind="matched" data-idx="${i}">
						<td>${it.cProd || ''}</td>
						<td>${it.xProd || ''}</td>
						<td>${it.sku || ''}</td>
						<td>${it.name || ''}</td>
						<td>${it.quantity ?? ''}</td>
						<td>${it.unit_price ?? ''}</td>
						<td><input type="hidden" class="io-xml-pid" value="${it.product_id}"></td>
					</tr>`).join('');
				const unmatchedRows = unmatched.map((it, i) => {
					const opts = (it.suggestions || []).map((s) =>
						`<option value="${s.product_id}">${s.sku || ''} — ${(s.name || '').toString().slice(0, 60)} (${Math.round((s.score || 0) * 100)}%)</option>`
					).join('');
					return `
					<tr data-kind="unmatched" data-idx="${i}">
						<td>${it.cProd || ''}</td>
						<td title="${(it.skip_reason || '').toString()}">${it.xProd || ''}${it.skip_reason ? ' ⚠' : ''}</td>
						<td colspan="2">
							<select class="io-xml-pid" style="width:100%">
								<option value="">— sem vínculo —</option>
								${opts}
							</select>
						</td>
						<td>${it.quantity ?? ''}</td>
						<td>${it.unit_price ?? ''}</td>
						<td></td>
					</tr>`;
				}).join('');
				const html = `
					<div class="msgbox" style="min-width:720px;max-width:960px;max-height:85vh;overflow:auto">
						<div class="mb-title">Confirmar importação XML</div>
						<div class="mb-text">
							<p style="margin:0 0 0.5rem">
								NF <strong>${preview.invoice_number || ''}</strong>
								${preview.invoice_series ? ` série ${preview.invoice_series}` : ''}
								— Emitente: ${(preview.emit_name || '')} (${preview.emit_cnpj || 'sem CNPJ'})
							</p>
							${preview.duplicate_warning ? `<p style="color:#a60;margin:0 0 0.5rem">${preview.duplicate_warning}</p>` : ''}
							<label style="display:block;margin:0.5rem 0">Fornecedor<sup>*</sup>
								<select id="io-xml-supplier" style="width:100%" required>
									<option value="">— selecione —</option>
									${supplierOptions}
								</select>
							</label>
							<p class="mts"><strong>Itens casados (${matched.length})</strong></p>
							<table class="bordered" style="width:100%;font-size:0.9em"><thead>
								<tr><th>cProd</th><th>Descrição XML</th><th>SKU</th><th>Produto</th><th>Qtd</th><th>Preço</th><th></th></tr>
							</thead><tbody>${matchedRows || '<tr><td colspan="7">Nenhum</td></tr>'}</tbody></table>
							<p class="mts"><strong>Sem match / sugestões (${unmatched.length})</strong></p>
							<table class="bordered" style="width:100%;font-size:0.9em"><thead>
								<tr><th>cProd</th><th>Descrição XML</th><th colspan="2">Associar produto</th><th>Qtd</th><th>Preço</th><th></th></tr>
							</thead><tbody>${unmatchedRows || '<tr><td colspan="7">Nenhum</td></tr>'}</tbody></table>
							<p style="margin:0.75rem 0 0;color:#666;font-size:0.92em">
								Cria Pedido (já aprovado) + Entrada com XML. Itens sem produto ficam de fora se confirmar parcial.
							</p>
						</div>
						<button type="button" class="button mtl bn_N">Cancelar</button>
						<button type="button" class="button mtl bn_Y">Confirmar</button>
					</div>
				`;
				const dlg = dialog.create(html, async (key) => {
					if (key === 'Escape' || key === 'N') {
						dlg.destroy();
						return;
					}
					if (key !== 'Y') return;
					const root = dlg.getNode();
					const supplier_id = root.querySelector('#io-xml-supplier')?.value;
					if (!supplier_id) {
						notify('Selecione o fornecedor.', 'Importar XML');
						return;
					}
					const items = [];
					let stillUnmatched = 0;
					matched.forEach((it) => {
						if (it.product_id && it.quantity > 0)
							items.push({ product_id: it.product_id, quantity: it.quantity, unit_price: it.unit_price });
					});
					root.querySelectorAll('tr[data-kind="unmatched"]').forEach((tr, i) => {
						const it = unmatched[i];
						const pid = tr.querySelector('.io-xml-pid')?.value;
						if (pid && it?.quantity > 0 && !it.skip_reason)
							items.push({ product_id: Number(pid), quantity: it.quantity, unit_price: it.unit_price });
						else
							stillUnmatched += 1;
					});
					if (!items.length) {
						notify('Nenhum item válido para importar.', 'Importar XML');
						return;
					}
					const doConfirm = async (confirm_partial) => {
						try {
							const result = await api.call(api.confirm_input_order_xml, company_id, {
								supplier_id: Number(supplier_id),
								program_id: program_id || null,
								invoice_number: preview.invoice_number,
								invoice_series: preview.invoice_series,
								volumes: preview.volumes,
								weight: preview.weight,
								xml_base64: preview.xml_base64,
								items,
								confirm_partial,
								unmatched_count: stillUnmatched,
							});
							dlg.destroy();
							notify(
								`Pedido #${result.order_id} e Entrada #${result.input_id} criados`
								+ (result.unmatched_skipped ? ` (${result.unmatched_skipped} item(ns) do XML sem vínculo).` : '.'),
								'Importação XML'
							);
							crudRef.loadPage();
						} catch (e) {
							notify(e?.message || String(e), 'Erro na importação');
						}
					};
					if (stillUnmatched > 0) {
						ask(
							`Há ${stillUnmatched} item(ns) do XML sem produto. Confirma importação parcial só com os itens vinculados?`,
							'Importação parcial',
							async (answer) => {
								if (answer === 'Y')
									await doConfirm(true);
							}
						);
					} else {
						await doConfirm(false);
					}
				}, /Escape|N|Y/);
				const sel = dlg.getNode()?.querySelector('#io-xml-supplier');
				if (sel && preview.supplier_id)
					sel.value = String(preview.supplier_id);
			};

			const sendRequest = async (data) =>
			{
				const formNode = document.querySelector(xml_import_form.form.selector);
				const fileInput = formNode?.querySelector('#file');
				const file = fileInput?.files?.[0];
				if (!file) {
					notify('Selecione o arquivo XML.');
					return;
				}
				const company_id = data.company_id;
				if (!company_id) {
					notify('Selecione a empresa.');
					return;
				}
				const fd = new FormData();
				fd.append('file', file);
				try {
					const preview = await api.call(api.preview_input_order_xml, company_id, fd);
					if (!preview) return;
					fs.destroy();
					await openConfirm(company_id, data.program_id || null, preview);
				} catch (e) {
					notify(e?.message || String(e), 'Erro ao analisar XML');
				}
			};
			const fs = formset.create(xml_import_form, sendRequest);
			fs.init = (() =>
			{
				Object.getPrototypeOf(fs).init.call(fs);
			})();
		},
		printOrderDocument()
		{
			if (!this.ensureSelection('Documento de Pedido de Entrada'))
				return;
			const showResult = async (resp) =>
			{
				this.clearGridSelection();
				if (resp?.pdf)
					pdf(resp.pdf);
			}
			const sendRequest = async () =>
			{
				let ids = await this.getSelectedIds(['company_id', 'id']);
				let resp = await api.call(api.print_input_order_document, { 'ids': ids }).then(showResult);
			}
			ask(`Gerar documento de ${this.getCount()} pedido(s)?`, 'Documento de Pedido de Entrada', (answer) =>
			{
				if (answer == 'Y')
					sendRequest();
			});
		},
		async approveOrders()
		{
			const selectedIds = await this.getSelectedIds(['company_id', 'id']);
			if (!selectedIds?.length) {
				notify('Selecione ao menos um pedido para aprovar.', 'Aprovar Selecionados');
				return;
			}
			const byCompany = {};
			for (const pair of selectedIds) {
				const [company_id, id] = pair;
				if (!byCompany[company_id]) byCompany[company_id] = [];
				byCompany[company_id].push(id);
			}
			const totalOrders = selectedIds.length;
			const html = `
				<div class="msgbox" style="min-width:340px;max-width:500px">
					<div class="mb-title">Aprovar Pedidos de Entrada</div>
					<div class="mb-text">
						<p style="margin:0 0 0.75rem">
							Confirma a aprovação de <strong>${totalOrders} pedido${totalOrders !== 1 ? 's' : ''}</strong> selecionado${totalOrders !== 1 ? 's' : ''}?
						</p>
						<p style="margin:0;color:#888;font-size:0.92em">
							Apenas pedidos com status <strong>Criado</strong> serão aprovados.
							Pedidos em outros status serão ignorados.
						</p>
					</div>
					<button type="button" class="button mtl bn_N">Cancelar</button>
					<button type="button" class="button mtl bn_Y">Aprovar</button>
				</div>
			`;
			const crudRef = this;
			const dlg = dialog.create(html, async (key) => {
				if (key === 'Escape' || key === 'N') {
					dlg.destroy();
					return;
				}
				if (key === 'Y') {
					dlg.destroy();
					try {
						let totalApproved = 0;
						let totalSkipped = 0;
						for (const [company_id, ids] of Object.entries(byCompany)) {
							const result = await api.call(api.approve_input_orders_batch, company_id, { ids });
							totalApproved += result?.approved || 0;
							totalSkipped += result?.skipped || 0;
						}
						if (totalApproved > 0) {
							notify(
								`${totalApproved} pedido${totalApproved !== 1 ? 's' : ''} aprovado${totalApproved !== 1 ? 's' : ''} com sucesso.` +
								(totalSkipped > 0 ? ` ${totalSkipped} ignorado${totalSkipped !== 1 ? 's' : ''} (status diferente de Criado).` : ''),
								'Aprovação em lote'
							);
							crudRef.loadPage();
						} else {
							notify('Nenhum pedido foi aprovado. Verifique se os pedidos selecionados estão com status Criado.', 'Aprovação em lote');
						}
					} catch (e) {
						notify(e?.message || String(e), 'Erro ao aprovar pedidos');
					}
				}
			}, /Escape|N|Y/);
		},
		async rejectOrders()
		{
			const selectedIds = await this.getSelectedIds(['company_id', 'id']);
			if (!selectedIds?.length) {
				notify('Selecione ao menos um pedido para rejeitar.', 'Rejeitar Selecionados');
				return;
			}
			const byCompany = {};
			for (const pair of selectedIds) {
				const [company_id, id] = pair;
				if (!byCompany[company_id]) byCompany[company_id] = [];
				byCompany[company_id].push(id);
			}
			const totalOrders = selectedIds.length;
			const html = `
				<div class="msgbox" style="min-width:360px;max-width:520px">
					<div class="mb-title">Rejeitar Pedidos de Entrada</div>
					<div class="mb-text">
						<p style="margin:0 0 0.75rem">
							Confirma a rejeição de <strong>${totalOrders} pedido${totalOrders !== 1 ? 's' : ''}</strong>?
							Pedidos passam para status <strong>Cancelado</strong>.
						</p>
						<p style="margin:0 0 0.5rem;color:#888;font-size:0.92em">
							Apenas pedidos com status <strong>Criado</strong> serão rejeitados.
						</p>
						<label style="display:block;margin:0.5rem 0 0.25rem">Motivo (opcional)</label>
						<textarea id="reject_reason" rows="3" style="width:100%;box-sizing:border-box" placeholder="Motivo da rejeição"></textarea>
					</div>
					<button type="button" class="button mtl bn_N">Cancelar</button>
					<button type="button" class="button mtl bn_Y">Rejeitar</button>
				</div>
			`;
			const crudRef = this;
			const dlg = dialog.create(html, async (key) => {
				if (key === 'Escape' || key === 'N') {
					dlg.destroy();
					return;
				}
				if (key === 'Y') {
					const reason = dlg.getNode()?.querySelector('#reject_reason')?.value?.trim() || '';
					dlg.destroy();
					try {
						let totalRejected = 0;
						let totalSkipped = 0;
						for (const [company_id, ids] of Object.entries(byCompany)) {
							const result = await api.call(api.reject_input_orders_batch, company_id, { ids, reason: reason || null });
							totalRejected += result?.rejected || 0;
							totalSkipped += result?.skipped || 0;
						}
						if (totalRejected > 0) {
							notify(
								`${totalRejected} pedido${totalRejected !== 1 ? 's' : ''} rejeitado${totalRejected !== 1 ? 's' : ''} com sucesso.` +
								(totalSkipped > 0 ? ` ${totalSkipped} ignorado${totalSkipped !== 1 ? 's' : ''} (status diferente de Criado).` : ''),
								'Rejeição em lote'
							);
							crudRef.loadPage();
						} else {
							notify('Nenhum pedido foi rejeitado. Verifique se os pedidos selecionados estão com status Criado.', 'Rejeição em lote');
						}
					} catch (e) {
						notify(e?.message || String(e), 'Erro ao rejeitar pedidos');
					}
				}
			}, /Escape|N|Y/);
		},
	});
	
	// Index = position in the backend's SELECT
	let fieldspecs = [
		{ index: 1, field: 'company_id', label: 'Empresa', types: [types.datalist()], placeholder: '', title: 'Empresa', store: 'companies', labels: ['nick'] },
		{ index: 2, field: 'id', label: 'Pedido', types: [types.number(0, 2)], placeholder: '0', title: 'Identificador do pedido' },
		{ index: 3, field: 'reference', label: 'Referência', types: [], placeholder: '', title: 'Código de referência externa do pedido' },
		{ index: 4, field: 'created_on', label: 'Data Criação', types: [types.datetime()], placeholder: 'dd/mm/aaaa hh:mm:ss', title: 'Data e hora de criação do pedido' },
		{ index: 5, field: 'created_by', label: 'Criado Por', types: [types.datalist()], placeholder: '', title: 'Usuário criador do pedido', store: 'users', labels: ['name'] },
		{ index: 6, field: 'updated_on', label: 'Data Alteração', types: [types.datetime()], placeholder: 'dd/mm/aaaa hh:mm:ss', title: 'Data e hora da última atualização do pedido' },
		{ index: 7, field: 'updated_by', label: 'Alterado Por', types: [types.datalist()], placeholder: '', title: 'Último usuário a atualizar o pedido', store: 'users', labels: ['name'] },
		{ index: 8, field: 'supplier_id', label: 'Fornecedor', types: [types.datalist()], placeholder: '', title: 'Fornecedor (CNPJ + apelido)', store: 'suppliers', labels: ['cnpj', 'nick'] },
		// Índices = posição no SQL_BASE_SELECT (repos/input_orders.py). customer_id=9 (sem coluna na grade).
		{ index: 10, field: 'carrier_id', label: 'Transportador', types: [types.datalist()], placeholder: '', title: 'Transportador', store: 'carriers', labels: ['nick'] },
		{ index: 11, field: 'program_id', label: 'Programa', types: [types.datalist()], placeholder: '', title: 'Programa sugerido para a entrada', store: 'programs', labels: ['name'] },
		{ index: 12, field: 'freight_type', label: 'Tipo Frete', types: [types.opt_freight_type(), types.datalist()], placeholder: '', title: 'Tipo de frete' },
		{ index: 13, field: 'freight_value', label: 'Valor Frete', types: [types.number(2)], placeholder: '0,00', title: 'Valor do frete' },
		{ index: 14, field: 'discount', label: '% Desconto', types: [types.number(2)], placeholder: '0,00', title: 'Percentual de desconto' },
		{ index: 15, field: 'value', label: 'Valor', types: [types.number(2)], placeholder: '0,00', title: 'Valor do pedido' },
		{ index: 16, field: 'notes', label: 'Observações', types: [], placeholder: '', title: 'Observações do pedido' },
		{ index: 18, field: 'empenho_number', label: 'Nº empenho', types: [], placeholder: '2025NE02173', title: 'Número do empenho (AAAA+NE+número)' },
		{ index: 19, field: 'amil_oc', label: 'OC Amil', types: [], placeholder: '4000222822', title: 'Ordem de compra (OC) AMIL para rastreio' },
		{ index: 20, field: 'receipt_type_id', label: 'Tipo recebimento', types: [types.datalist()], placeholder: '', title: 'Tipo de recebimento', store: 'receipt_types', labels: ['code', 'description'] },
		{ index: 21, field: 'is_return', label: 'Devolução', types: [types.opt_bool(), types.datalist()], placeholder: '', title: 'Indicador de devolução' },
		{ index: 17, field: 'nf_number', label: 'NF', types: [], placeholder: '', title: 'NF de entrada do fornecedor (agrupador)' },
		{ index: 28, field: 'fulfillment_status', label: 'Atendimento', types: [types.opt_input_order_fulfillment(), types.datalist()], placeholder: '', title: 'Pendente / Parcial / Atendido total (vs entradas concluídas)' },
		{ index: 22, field: 'status', label: 'Status', types: [types.opt_input_order_status(), types.datalist()], placeholder: '', title: 'Status do pedido' },
		{ index: 23, field: 'payment_installment_count', label: 'Qtd parcelas', types: [types.number(0, 2)], placeholder: '', title: 'Quantidade de parcelas da condição de pagamento' },
		{ index: 30, field: 'lines_sku_summary', label: 'SKU (itens)', types: [], placeholder: 'trecho do SKU', title: 'Busca nos SKUs das linhas do pedido (operador Contém recomendado)' },
		{ index: 31, field: 'lines_product_summary', label: 'Produto (itens)', types: [], placeholder: 'nome do produto', title: 'Busca nos nomes dos produtos das linhas (operador Contém recomendado)' },
	];

	let operations = [
		{ hash: '#upload', label: 'Upload&nbsp;planilha' },
		{ hash: '#import-xml', label: 'Importar&nbsp;XML&nbsp;NF-e' },
		{ hash: '#approve-orders', label: 'Aprovar&nbsp;selecionados' },
		{ hash: '#reject-orders', label: 'Rejeitar&nbsp;selecionados' },
	];

	let reports = [
		{ hash: '#print-order-doc', label: 'Documento&nbsp;do&nbsp;Pedido' },
	];

	router.set('#upload', input_orders_crud.uploadFromSpreadsheet.bind(input_orders_crud));
	router.set('#import-xml', input_orders_crud.importFromXml.bind(input_orders_crud));
	router.set('#approve-orders', input_orders_crud.approveOrders.bind(input_orders_crud));
	router.set('#reject-orders', input_orders_crud.rejectOrders.bind(input_orders_crud));
	router.set('#print-order-doc', input_orders_crud.printOrderDocument.bind(input_orders_crud));

	input_orders_crud.run(
		'input_orders',
		'Pedidos&nbsp;Entrada',
		document.getElementById('workarea'),
		view,
		form,
		fieldspecs,
		operations,
		reports
	);

};

export default inputOrders;

